import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=4b50872e&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"
import style0 from "./refund.vue?vue&type=style&index=0&id=4b50872e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50872e",
  null
  
)

export default component.exports